import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerBuilderMenuMobileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_21718_3316)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M9.79999 4.20002C9.67783 4.32464 9.60941 4.49218 9.60941 4.66668C9.60941 4.84119 9.67783 5.00873 9.79999 5.13335L10.8667 6.20002C10.9913 6.32217 11.1588 6.39059 11.3333 6.39059C11.5078 6.39059 11.6754 6.32217 11.8 6.20002L13.8707 4.13002C14.084 3.91535 14.446 3.98335 14.526 4.27535C14.7274 5.00793 14.716 5.78273 14.4932 6.50908C14.2703 7.23543 13.8452 7.88329 13.2676 8.37684C12.69 8.8704 11.9837 9.18924 11.2315 9.29606C10.4793 9.40288 9.71218 9.29326 9.01999 8.98002L3.74665 14.2533C3.48144 14.5185 3.12176 14.6674 2.74675 14.6673C2.37174 14.6673 2.01211 14.5182 1.74699 14.253C1.48186 13.9878 1.33295 13.6281 1.33301 13.2531C1.33307 12.8781 1.4821 12.5185 1.74732 12.2533L7.02065 6.98002C6.70741 6.28783 6.59779 5.52074 6.70461 4.76852C6.81143 4.0163 7.13027 3.31005 7.62383 2.73243C8.11738 2.1548 8.76524 1.72969 9.49159 1.50684C10.2179 1.28398 10.9927 1.2726 11.7253 1.47402C12.0173 1.55402 12.0853 1.91535 11.8713 2.13002L9.79999 4.20002Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M9.79999 4.20002C9.67783 4.32464 9.60941 4.49218 9.60941 4.66668C9.60941 4.84119 9.67783 5.00873 9.79999 5.13335L10.8667 6.20002C10.9913 6.32217 11.1588 6.39059 11.3333 6.39059C11.5078 6.39059 11.6754 6.32217 11.8 6.20002L13.8707 4.13002C14.084 3.91535 14.446 3.98335 14.526 4.27535C14.7274 5.00793 14.716 5.78273 14.4932 6.50908C14.2703 7.23543 13.8452 7.88329 13.2676 8.37684C12.69 8.8704 11.9837 9.18924 11.2315 9.29606C10.4793 9.40288 9.71218 9.29326 9.01999 8.98002L3.74665 14.2533C3.48144 14.5185 3.12176 14.6674 2.74675 14.6673C2.37174 14.6673 2.01211 14.5182 1.74699 14.253C1.48186 13.9878 1.33295 13.6281 1.33301 13.2531C1.33307 12.8781 1.4821 12.5185 1.74732 12.2533L7.02065 6.98002C6.70741 6.28783 6.59779 5.52074 6.70461 4.76852C6.81143 4.0163 7.13027 3.31005 7.62383 2.73243C8.11738 2.1548 8.76524 1.72969 9.49159 1.50684C10.2179 1.28398 10.9927 1.2726 11.7253 1.47402C12.0173 1.55402 12.0853 1.91535 11.8713 2.13002L9.79999 4.20002Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_21718_3316",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgHypertrackerBuilderMenuMobileIcon;
